
import { useState } from 'react';
import React from 'react';

import data from './blog2.js';
import './Latestblog.css';


function Latestblog () {

let [blog2] = useState(data); 

    return (
        <div>
            <div className='container' style={{background:"#eee", height:"30px"}}>
                <Category/>
            </div>

            <Title/>

            <div className='container'>
                <div className='row'>
                    {
                        blog2.map((a,i)=>{
                            return(
                                <Blog2 blog2={blog2[i]} i={i+1}></Blog2>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
};


function Category () {

    let ulcss={
        listStyle:"none"
    }
    let licss={
        float:"left",
        padding:"2px 4px",
        color:"#666",
        fontWeight:"400",
        cursor:"pointer"
    }
    return (
        <ul style={ulcss}>
            <li style={licss}>Home</li>
            <li style={licss}>|</li>
            <li style={licss}>News</li>
        </ul>
    );
};

function Title () {
    let h2={
        marginTop:"50px",
        marginBottom:"30px",
        textAlign:"center",
        fontWeight:"700"
    }

    return (
        <h2 style={h2}>News</h2>
    );
};


function Blog2 (props){
    let boxwrap={
        marginBottom:"30px"
    }

    let textBox={
        padding:"1% 3%",
        display:"flex",
        flexWrap:"wrap",
        justifyContent:"center"
    }

    let p={
        fontSize:"18px"
    }
    return (
        <div className='col-md-6' style={boxwrap}>
            <div className='col-md-12'>
                <div id="imgbox">
                    <img src={props.blog2.imgUrl} width="100%" height="100%"/>
                </div>
                <div style={textBox}>
                    <p style={p} id="text">{props.blog2.title}</p>
                    <p>{props.blog2.contents}</p>
                    <List></List>
                </div>
            </div>
            
        </div>
    );
};



function List () {
    let num = Math.floor(Math.random()*10);
    let box={
        marginTop:"10px",
        padding:0,
    }

    let li={
        listStyle:"none",
        float:"left",
        margin:"0 20px 0 0px",
        fontSize:"13px",

    }
    return (
        <div style={box}>
            <ul>
                <li style={li}>Winter infotech</li>
                <li style={li}>July 7,2022</li>
                <li style={li}>{num} comments</li>
            </ul>
        </div>
    );
};



export default Latestblog;